<mat-toolbar class="content-header">
    <mat-icon class="header-icon" fontIcon="vpn_key"></mat-icon>
    <h1 class="page-title">{{'users.access_management' | translate}}</h1>
    <span class="toolbar-spacer"></span>
    <div class="toolbar-menu">
        <div *ngIf="!creatingAccess">
            <lib-button class="add-button" (click)="addAccessForm()" color="primary"
                tooltip="{{'users.add_access' | translate}}" icon="add">
            </lib-button>
        </div>

        <app-search-bar (searchText)="search($event)"> </app-search-bar>
    </div>
</mat-toolbar>

<ng-container>
    <div class="access-container">


        <div class="option-menu">
            <div class="table-container" [ngClass]="{'width-70': currentAccess}">
                <table mat-table [dataSource]="accessData" matSort>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <div class="header-content">
                                <mat-icon fontIcon="vpn_key"></mat-icon>
                                {{'form.name'|translate}}
                            </div>
                        </th>

                        <td mat-cell *matCellDef="let row" class="mat-column-name"
                            [ngClass]="{ active: row.id == currentAccess?.id }"> {{row.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="author">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <div class="header-content">
                                <mat-icon fontIcon="person"></mat-icon>
                                {{'form.created_by'|translate}}
                            </div>
                        </th>

                        <td mat-cell *matCellDef="let row" class="mat-column-author"
                            [ngClass]="{ active: row.id == currentAccess?.id }">
                            {{ (row.author && (row.author.firstName || row.author.lastName)) ? (row.author.firstName + '
                            ' + row.author.lastName) : 'CAD.42' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <div class="header-content">
                                <mat-icon fontIcon="edit"></mat-icon>
                                Actions
                            </div>
                        </th>

                        <td mat-cell *matCellDef="let row" class="mat-column-actions">
                            <ng-container *ngIf="canEdit(row)">
                                <lib-button icon="edit" textColor="secondary" color="none" (click)="editAccess(row)">
                                </lib-button>

                                <lib-button textColor="danger" color="none" icon="delete" (click)="deleteAccess(row)">
                                </lib-button>
                            </ng-container>

                            <ng-container *ngIf="!canEdit(row)">
                                <lib-button color="none" textColor="secondary" icon="visibility"
                                    (click)="editAccess(row)">
                                </lib-button>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="accessColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: accessColumns;"></tr>

                    <tr class="mat-row no-data-row" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="accessColumns.length">
                            <lib-no-data message="form.search_no_data" description="form.search_no_data_desc"
                                icon="search_off">
                            </lib-no-data>
                        </td>
                    </tr>
                </table>

                <mat-paginator #accessPaginator [length]="accessCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
                    class="paginator"></mat-paginator>
            </div>

            <mat-card class="access-form" *ngIf="currentAccess">
                <div class="form-header">
                    <mat-icon fontIcon="edit" *ngIf="canEdit(currentAccess) && currentAccess.id"></mat-icon>
                    <mat-icon fontIcon="add" *ngIf="canEdit(currentAccess) && !currentAccess.id"></mat-icon>
                    <mat-icon fontIcon="visibility" *ngIf="!canEdit(currentAccess)"></mat-icon>
                    <span class="form-title">
                        {{ canEdit(currentAccess) ? (currentAccess.id ? ('access.editing' | translate) : ('access.new' |
                        translate)) : ('access.reading' | translate) }}
                    </span>
                </div>

                <div class="access-name mb-2">
                    <mat-form-field appearance="outline" class="input flex-grow" subscriptSizing="dynamic">
                        <mat-label>{{'access.name'|translate}}</mat-label>
                        <input matInput required placeholder="{{'access.name'|translate}}" name="accessName"
                            [(ngModel)]="currentAccess.name" (change)="updated()" minlength="3" #nameInput="ngModel"
                            [disabled]="!canEdit(currentAccess)">
                        <mat-error *ngIf="nameInput.invalid && nameInput.touched">
                            {{ 'form.error.min_char' | translate:{min: 3} }}
                        </mat-error>
                    </mat-form-field>

                    <mat-checkbox *ngIf="isAdmin" [disabled]="!canEdit(currentAccess)"
                        [(ngModel)]="currentAccess.adminAccess" [labelPosition]="'after'" (change)="updated()">
                        {{ 'access.admin_access'|translate}}
                    </mat-checkbox>
                </div>

                <div class="row">
                    <div class="chips">
                        <div class="section-title">
                            <mat-icon fontIcon="apps"></mat-icon>
                            {{'access.services'|translate}}
                        </div>

                        <div class="services-list">
                            <mat-chip-set>
                                <mat-chip *ngFor="let key of serviceKeys" [disabled]="!canEdit(currentAccess)">
                                    <mat-checkbox [disabled]="!canEdit(currentAccess)"
                                        [(ngModel)]="currentAccess.services[key]" [labelPosition]="'after'"
                                        (change)="updated()" class="chip-checkbox">
                                        {{('title.' + key)|translate}}
                                    </mat-checkbox>
                                </mat-chip>
                            </mat-chip-set>
                        </div>

                        <div class="section-title">
                            <mat-icon fontIcon="folder_shared"></mat-icon>
                            {{'access.projects'|translate}}
                        </div>

                        <div class="projects-list">
                            <div *ngFor="let project of labelProjects" class="project-checkbox">
                                <mat-checkbox [disabled]="!canEdit(currentAccess)"
                                    [(ngModel)]="projectDisplayer[project.id]" [labelPosition]="'after'"
                                    (change)="updated({ project: project.id })">
                                    {{ project.displayName }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="permissions">
                        <div class="section-title">
                            <mat-icon fontIcon="api"></mat-icon>
                            {{'access.api_permissions'|translate}}
                        </div>

                        <div class="api-permissions-table-wrapper">
                            <table class="api-permissions">
                                <thead>
                                    <tr>
                                        <th>API</th>
                                        <th>{{'access.read'|translate}}</th>
                                        <th>{{'access.write'|translate}}</th>
                                        <th>{{'access.admin'|translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let key of apiKeys">
                                        <td>{{ ('access.' + key)|translate }}</td>
                                        <td>
                                            <mat-checkbox [disabled]="!canEdit(currentAccess)"
                                                [(ngModel)]="currentAccess.api[key].read"
                                                (change)="updated()"></mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-checkbox [disabled]="!canEdit(currentAccess)"
                                                [(ngModel)]="currentAccess.api[key].write"
                                                (change)="updated()"></mat-checkbox>
                                        </td>
                                        <td>
                                            <mat-checkbox [disabled]="!canEdit(currentAccess)"
                                                [(ngModel)]="currentAccess.api[key].admin"
                                                (change)="updated()"></mat-checkbox>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="submit" style="justify-content: flex-end;">
                    <lib-button (click)="close()" icon="close" color="outline"
                        text="{{'form.close'|translate}}"></lib-button>
                    <lib-button *ngIf="canEdit(currentAccess)" color="primary" icon="save" (click)="saveAccess()"
                        text="{{'form.save'|translate}}"></lib-button>
                </div>
            </mat-card>
        </div>
    </div>
</ng-container>